import React from "react";
import { ResponsiveLineCanvas } from "@nivo/line";

const ECG_LENGTH = 150;

const gridXValues = Array.from(Array(25), (e, i) => (i * (12 * ECG_LENGTH)) / 3 / 24);
const gridYValues = Array.from(Array(19), (e, i) => (i - 9) * 0.5);

export const PlotECG = React.memo(function PlotECG({ ecg, original }: any) {
  if (original) {
    return (
      <ResponsiveLineCanvas
        data={ecg}
        lineWidth={1.5}
        curve={"basis"}
        colors={"#bfbfbf"}
        yFormat=" >-.2f"
        yScale={{ type: "linear", stacked: false, min: -4.5, max: 4.5 }}
        xScale={{ type: "linear", stacked: false, min: 0, max: (12 * ECG_LENGTH) / 3 }}
        axisTop={null}
        axisRight={null}
        axisBottom={null}
        axisLeft={null}
        enableGridX={true}
        gridXValues={gridXValues}
        enableGridY={true}
        gridYValues={gridYValues}
        enablePoints={false}
        isInteractive={false}
      />
    );
  } else {
    return (
      <ResponsiveLineCanvas
        data={ecg}
        lineWidth={1.5}
        curve={"basis"}
        colors={"#000000"}
        yFormat=" >-.2f"
        yScale={{ type: "linear", stacked: false, min: -4.5, max: 4.5 }}
        xScale={{ type: "linear", stacked: false, min: 0, max: (12 * ECG_LENGTH) / 3 }}
        axisTop={null}
        axisRight={null}
        axisBottom={null}
        axisLeft={null}
        enableGridX={false}
        enableGridY={false}
        enablePoints={false}
        isInteractive={false}
      />
    );
  }
});
